module.exports = __webpack_public_path__ + "sx2-fbf1964a.png";